import {
    FaAngleDown,
    FaAngleLeft,
    FaAngleRight,
    FaArrowLeft,
    FaArrowRight,
    FaAsterisk,
    FaBan,
    FaBook,
    FaBrain,
    FaBriefcase,
    FaBug,
    FaBuilding,
    FaCalendarAlt,
    FaChartLine,
    FaCheck,
    FaCheckCircle,
    FaCode,
    FaCompress,
    FaDownload,
    FaDumbbell,
    FaExclamationTriangle,
    FaExpand,
    FaEye,
    FaEyeSlash,
    FaFile,
    FaFlask,
    FaGlobe,
    FaGraduationCap,
    FaGripVertical,
    FaHeartbeat,
    FaInfo,
    FaInfoCircle,
    FaKey,
    FaLaptop,
    FaMapMarkerAlt,
    FaMedal,
    FaMemory,
    FaNetworkWired,
    FaPercent,
    FaPlane,
    FaQuestionCircle,
    FaRoute,
    FaSignOutAlt,
    FaSpinner,
    FaStar,
    FaTimes,
    FaTrophy,
    FaUniversity,
    FaUpload,
    FaUser,
    FaUsers,
    FaWhatsapp,
    FaCoins,
    FaCalendar,
    FaLightbulb,
    FaUserGraduate,
    FaMinus,
    FaClock,
    FaChalkboardTeacher
} from 'react-icons/fa'
import { FaArrowsSpin } from 'react-icons/fa6'
import { FcNews } from 'react-icons/fc'
import { IoIosAlert, IoMdMegaphone } from 'react-icons/io'
import { IoPeopleCircle } from 'react-icons/io5'
import { LuFileCheck2 } from 'react-icons/lu'
import { MdSupportAgent } from 'react-icons/md'
import { PiUserCircleCheckBold } from 'react-icons/pi'
import { RiArrowLeftWideLine, RiArrowRightWideLine } from 'react-icons/ri'
import { TbHomeCheck } from 'react-icons/tb'
export const Icons = {
    Eye: FaEye,
    EyeSlash: FaEyeSlash,
    ArrowLeft: FaArrowLeft,
    Key: FaKey,
    Bug: FaBug,
    Compress: FaCompress,
    Expand: FaExpand,
    Code: FaCode,
    ArrowRight: FaArrowRight,
    SignOutAlt: FaSignOutAlt,
    User: FaUser,
    ChartLine: FaChartLine,
    Memory: FaMemory,
    Download: FaDownload,
    NetworkWired: FaNetworkWired,
    ExclamationTriangle: FaExclamationTriangle,
    Ban: FaBan,
    Route: FaRoute,
    Info: FaInfo,
    AngleDown: FaAngleDown,
    Support: MdSupportAgent,
    AngleLeft: FaAngleLeft,
    AngleRight: FaAngleRight,
    ArrowRightWideLine: RiArrowRightWideLine,
    ArrowLeftWideLine: RiArrowLeftWideLine,
    CheckCircle: FaCheckCircle,
    Asterisk: FaAsterisk,
    Brain: FaBrain,
    Spinner: FaSpinner,
    Times: FaTimes,
    Upload: FaUpload,
    File: FaFile,
    FileCheck: LuFileCheck2,
    IosAlert: IoIosAlert,
    University: FaUniversity,
    BookIcon: FaBook,
    Globe: FaGlobe,
    Medal: FaMedal,
    Star: FaStar,
    GraduationCap: FaGraduationCap,
    CalendarAlt: FaCalendarAlt,
    Percent: FaPercent,
    InfoCircle: FaInfoCircle,
    Plane: FaPlane,
    Briefcase: FaBriefcase,
    Heartbeat: FaHeartbeat,
    Users: FaUsers,
    Laptop: FaLaptop,
    Trophy: FaTrophy,
    Building: FaBuilding,
    Flask: FaFlask,
    Dumbbell: FaDumbbell,
    Check: FaCheck,
    Exclamation: FaExclamationTriangle,
    Question: FaQuestionCircle,
    GripVertical: FaGripVertical,
    Whatsapp: FaWhatsapp,
    Process: FaArrowsSpin,
    Economy: FaCoins,
    Calendar: FaCalendar,
    Light: FaLightbulb,
    UserGraduate: FaUserGraduate,
    Minus: FaMinus,
    Clock: FaClock,
    Megaphone: IoMdMegaphone,
    UserCheck: PiUserCircleCheckBold,
    Home: TbHomeCheck,
    People: IoPeopleCircle,
    Interview: FaChalkboardTeacher,
    News: FcNews,
    Location: FaMapMarkerAlt
}
